import { graphql } from 'msw';
import { gqlMocks } from './mockNavData';
import { addProfileModalMock } from './mockAddProfileModalData';
import {
  GetNavDataDocument,
  type GetNavDataQuery,
} from './components/NavContextWrapper/getNavData';
import { GET_RECENT_SEARCHES } from './components/Header/LoggedInHeader/MyAccount/Search/SearchDropdown/getRecentSearches';
import { recentSearchesMock } from './components/Header/LoggedInHeader/MyAccount/Search/SearchDropdown/mockData';
import { GetAddProfileIngressModalDocument } from './components/Header/LoggedInHeader/MyAccount/Dropdown/HouseholdMembers/AddProfileModal/getAddProfileModal';

/**
 * Mock Service Worker (MSW) handler for knit's navigation graphql query.
 *
 * @param mockData - graphql mock response. Defaults to a logged-in status.
 */
export const mswKnitHandler = (mockData: GetNavDataQuery = gqlMocks.loggedIn) =>
  graphql.query(GetNavDataDocument, (_req, res, ctx) => {
    return res(ctx.data(mockData));
  });

export const mswKnitRecentSearchesHandler = () =>
  graphql.query(GET_RECENT_SEARCHES, (_req, res, ctx) => {
    return res(ctx.data(recentSearchesMock.result.data));
  });

export const mswAddProfileModalHandler = () =>
  graphql.query(GetAddProfileIngressModalDocument, (_req, res, ctx) => {
    return res(ctx.data(addProfileModalMock));
  });

export const mswAddProfileModalErrorHandler = () =>
  graphql.query(GetAddProfileIngressModalDocument, (_req, res, ctx) => {
    return res(ctx.errors([{ message: 'there was a problem' }]));
  });
